import React, { useContext } from 'react';
import { DishesContext, IDishesContext } from '../Dishes/dishesState/dishesContext';
import ModalLayout from 'components/ModalLayout';
import DishFullInfoState from './dishFullInfoState/DishFullInfoState';
import DishFullInfoView from './components/DishFullInfoModal/DishFullInfoView';

const DishFullInfoPage: React.FC = () => {
	const { dishIDForFullInfo, setDishIDForFullInfo } = useContext<IDishesContext>(DishesContext);

	const handleClose = () => {
		setDishIDForFullInfo('');
	};

	return (
		<DishFullInfoState>
			<ModalLayout isVisible={!!dishIDForFullInfo} setIsShowModal={handleClose}>
				<DishFullInfoView />
			</ModalLayout>
		</DishFullInfoState>
	);
};

export default DishFullInfoPage;
